import { defineStore } from 'pinia';
import actions from './actions';
function initState() {
    return {
        listing: [],
        showSliderBtns: false
    };
}

export default (storeName) => defineStore(storeName, {
    state: initState,
    actions
});
